G.StrObjGroup = function(x,y,importObj){
	
	Phaser.Group.call(this,game);

	this.x = x || 0;
	this.y = y || 0;

	this.importObj = typeof importObj === 'string' ? JSON.parse(importObj) : importObj;

	this.parseImportObj(this.importObj);

};

G.StrObjGroup.prototype = Object.create(Phaser.Group.prototype);

G.StrObjGroup.prototype.parseImportObj = function(importObj){

	for (var i = 0; i < importObj.length; i++){

		var chunk = importObj[i];

		var img = G.makeImage(chunk.x,chunk.y,chunk.frame,chunk.anchor,this);
		img.scale.setTo(chunk.scale[0],chunk.scale[1]);
		img.angle = chunk.angle;

	}	

};